import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HistoryDashboard } from "./HistoryDashboard";
import "../../src/web/workbench-entry.css";
import "./history-dashboard.css";
import "./history-controls.css";

const root = document.getElementById("root");
if (!root) throw new Error("PhaseDrift cloud history root is missing");
createRoot(root).render(<StrictMode><HistoryDashboard /></StrictMode>);
